import React from "react";
import { Container, Row, Col, Button, Badge } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Configuración mejorada del slider
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
  ],
};

// Tipos TypeScript para mejor tipado
interface ProductData {
  id: string;
  image: string;
  name: string;
  description: string;
  clave: string;
  price: string;
  originalPrice?: string;
  discount?: string;
  badge?: string;
  inStock: boolean;
}

const cat_data: ProductData[] = [
  {
    id: "1",
    image: "/images/home/product-1-c.jpg",
    name: "Fermentis - SafBrew DA16 (500 grs)",
    description: "Levadura especializada para cervezas de alta fermentación",
    clave: "LC22",
    price: "MXN $2,481.40",
    originalPrice: "MXN $2,800.00",
    discount: "15%",
    badge: "Nuevo",
    inStock: true,
  },
  {
    id: "2",
    image: "/images/home/product-2-c.jpg",
    name: "Tabletas Campden (5 paquetes con 50 pzas cada uno)",
    description: "Conservante natural para estabilizar tu cerveza",
    clave: "HB025",
    price: "MXN $401.65",
    badge: "Popular",
    inStock: true,
  },
  {
    id: "3",
    image: "/images/home/product-4-c.jpg",
    name: "Fermentis - SafSpirit M-1 (Malt) (500 grs)",
    description: "Enzima especializada para destilación de malta",
    clave: "LCS01",
    price: "MXN $927.23",
    originalPrice: "MXN $1,100.00",
    discount: "20%",
    badge: "Oferta",
    inStock: true,
  },
  {
    id: "4",
    image: "/images/home/product-5-c.jpg",
    name: "Lúpulo US Sabro (500 grs)",
    description: "Lúpulo americano con notas tropicales y cítricas",
    clave: "LC22",
    price: "MXN $2,481.40",
    badge: "Premium",
    inStock: false,
  },
  {
    id: "5",
    image: "/images/home/product-5-c.jpg",
    name: "Lúpulo US Sabro (500 grs)",
    description: "Lúpulo americano con notas tropicales y cítricas",
    clave: "LC22",
    price: "MXN $2,481.40",
    badge: "Premium",
    inStock: true,
  },
];
const FeaturedProducts: React.FC = () => {
  return (
    <section className="featured-products bg-white">
      <Container className="py-5">
        {/* Header mejorado */}
        <Row className="mb-4">
          <Col>
            <div className="text-center mb-4">
              <h2 className="display-5 fw-bold text-dark mb-2">
                Productos Destacados
              </h2>
              <p className="lead text-muted">
                Descubre los ingredientes más populares para tu cerveza artesanal
              </p>
            </div>
          </Col>
        </Row>

        {/* Slider con estilos personalizados */}
        <div className="position-relative">
          <Slider {...settings} className="featured-slider">
            {cat_data.map((product) => (
              <Featured
                key={product.id}
                product={product}
              />
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  );
};

export default FeaturedProducts;

// Estilos CSS personalizados para el slider
const styles = `
  .featured-slider {
    padding: 0 15px;
  }
  
  .featured-slider .slick-slide {
    padding: 0 8px;
  }
  
  .featured-slider .slick-dots {
    bottom: -50px;
  }
  
  .featured-slider .slick-dots li button:before {
    font-size: 12px;
    color: #6c757d;
  }
  
  .featured-slider .slick-dots li.slick-active button:before {
    color: #0d6efd;
  }
  
  .featured-slider .slick-prev,
  .featured-slider .slick-next {
    width: 40px;
    height: 40px;
    background: rgba(255,255,255,0.9);
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 2;
  }
  
  .featured-slider .slick-prev:before,
  .featured-slider .slick-next:before {
    color: #0d6efd;
    font-size: 16px;
  }
  
  .featured-slider .slick-prev {
    left: -20px;
  }
  
  .featured-slider .slick-next {
    right: -20px;
  }
  
  .product-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(0,0,0,0.05);
    overflow: hidden;
    margin: 8px 0;
  }
  
  .product-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
    border-color: rgba(13, 110, 253, 0.2);
  }
  
  .product-image-container {
    transition: transform 0.3s ease;
  }
  
  .product-card:hover .product-image-container {
    transform: scale(1.02);
  }
  
  .product-image-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%);
    transform: translateX(-100%);
    transition: transform 0.6s ease;
    pointer-events: none;
  }
  
  .product-card:hover .product-image-container::before {
    transform: translateX(100%);
  }
  
  @media (max-width: 768px) {
    .featured-slider .slick-prev,
    .featured-slider .slick-next {
      display: none !important;
    }
    
    .featured-slider {
      padding: 0 5px;
    }
    
    .featured-slider .slick-slide {
      padding: 0 4px;
    }
  }
`;

// Inyectar estilos
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

interface FeaturedProps {
  product: ProductData;
}

const Featured: React.FC<FeaturedProps> = ({ product }) => {
  const {
    image,
    name,
    description,
    clave,
    price,
    originalPrice,
    discount,
    badge,
    inStock
  } = product;

  return (
    <div className="product-card h-100">
      <div 
        className="product-image-container position-relative overflow-hidden rounded-3"
        style={{ 
          height: '250px',
          backgroundImage: `url(${image})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#ffffff',
          padding: '20px'
        }}
      >
        
        {/* Badge de estado */}
        {badge && (
          <Badge 
            className="position-absolute top-0 start-0 m-3"
            bg={badge === 'Nuevo' ? 'success' : 
                 badge === 'Popular' ? 'primary' : 
                 badge === 'Oferta' ? 'warning' : 'info'}
            style={{ fontSize: '0.75rem' }}
          >
            {badge}
          </Badge>
        )}

        {/* Indicador de descuento */}
        {discount && (
          <Badge 
            className="position-absolute top-0 end-0 m-3"
            bg="danger"
            style={{ fontSize: '0.75rem' }}
          >
            -{discount}
          </Badge>
        )}

        {/* Botón de favoritos */}
        <button 
          className="position-absolute top-0 end-0 m-3 btn btn-sm btn-light rounded-circle"
          style={{ 
            width: '32px', 
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        >
          <i className="far fa-heart"></i>
        </button>
      </div>

      {/* Contenido del producto */}
      <div className="p-3">
        {/* Código del producto */}
        <div className="mb-2">
          <small className="text-muted fw-semibold">Código: {clave}</small>
        </div>

        {/* Nombre del producto */}
        <h6 className="fw-bold text-dark mb-2" style={{ 
          fontSize: '0.95rem',
          lineHeight: '1.3',
          minHeight: '2.6rem',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}>
          {name}
        </h6>

        {/* Descripción */}
        <p className="text-muted small mb-3" style={{
          fontSize: '0.8rem',
          lineHeight: '1.4',
          minHeight: '2.2rem',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}>
          {description}
        </p>

        {/* Precios */}
        <div style={{ minHeight: '60px' }}>
          <div className="d-flex flex-column">
            {originalPrice ? (
              <>
                <span className="text-muted text-decoration-line-through small mb-1">
                  {originalPrice}
                </span>
                <span className="fw-bold text-dark fs-5">{price}</span>
              </>
            ) : (
              <div className="d-flex align-items-center" style={{ height: '40px' }}>
                <span className="fw-bold text-dark fs-5">{price}</span>
              </div>
            )}
          </div>
        </div>

        {/* Botón de acción */}
        <div className="d-grid">
          <Button
            variant={inStock ? "warning" : "secondary"}
            size="sm"
            className="fw-bold rounded-pill"
            disabled={!inStock}
            style={{
              transition: 'all 0.3s ease',
              border: inStock ? '2px solid #ffc107' : '2px solid #e9ecef',
              backgroundColor: inStock ? '#ffc107' : '#f8f9fa',
              color: inStock ? '#000000' : '#000000',
              boxShadow: inStock ? '0 2px 8px rgba(255, 193, 7, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={(e) => {
              if (inStock) {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {inStock ? (
              <>
                <i className="fas fa-shopping-cart me-3" style={{ marginRight: '8px' }}></i>
                Agregar al Carrito
              </>
            ) : (
              <>
                <i className="fas fa-times me-3" style={{ marginRight: '8px' }}></i>
                Sin Stock
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
